import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"

// The describe page's backstop (TASK-266.2). The generation job broadcasts
// every transition, but a broadcast sent before the page subscribed — an
// instant gate refusal, say — is gone. While the draft panel is in flight it
// asks the server now and then; the answer is empty until the job has
// finished, then it is the same three replaces a broadcast would carry, which
// swap this panel out and stop the polling.
export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 3000 }, interval: { type: Number, default: 10000 } }

  connect() {
    this.timer = setTimeout(() => this.poll(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })
      const body = response.ok ? await response.text() : ""
      if (body.trim().length > 0) renderStreamMessage(body)
    } catch (_error) {
      // A missed poll is harmless; the next one, or the broadcast, catches up.
    }
    if (this.element.isConnected) this.timer = setTimeout(() => this.poll(), this.intervalValue)
  }
}
